<template>
    <PopUpDialog
        :show="displayPopUp"
        :hasButtons="false"
        :closeable="false"
        @closeModal="closePopUp"
        :isBlured="true">
        <template #bodyContainer>
            <div
                id="dialog"
                class="flex w-full flex-col border-[#65686E] bg-[#141414] bg-transparent py-6 px-10">
                <div class="flex flex-col items-center justify-center">
                    <img src="https://sm.naughtycdn.com/images/18+.svg" class="mb-2" alt="18+ Icon" />
                    <img src="https://sm.naughtycdn.com/images/www/naughty-america-logo.png" class="max-w-[300px] mb-2" alt="NA Logo"/>
                    <p class="text-[14px] text-[#fff] m-0 p-0">
                        NaughtyAmerica.com - Nobody does it better. <span>®</span>
                    </p>
                    <h1
                        class="mx-auto my-6 flex w-auto text-center text-[19px] md:text-[25px] font-semibold text-[#fff]">
                        Discover Naughty America Auditions
                    </h1>
                    <p class="text-[#AFAFAF text-[18px] mb-4">
                        This website contains sexually explicit material.
                    </p>
                    <div class="max-h-[90px] p-4 overflow-auto bg-black text-sm">
                        <p>
                            I am at least 18 years of age and have the legal right to access and possess adult material in the community from which I am accessing these materials and in which I reside. I will not permit any person(s) under the age of 18 (or who are otherwise not legally permitted) to have access to any of the materials contained on this website. I acknowledge that I am voluntarily requesting and choosing to receive the materials described above for my own personal use, information and/or education and that in no way am I being sent any information without my permission. I am not offended by materials of an adult nature, nor do I find such materials objectionable. I will exit from the website immediately in the event that I am in any way offended by any material found on the website. I am familiar with, understand and agree to comply with the standards and laws of the community in which I live and from which I am gaining access. I agree that I will not hold the creators, owners or operators of this website, or their employees, responsible for any materials or links contained on these pages. I understand that if I violate these terms or any provision of the Terms of Use, I may be in violation of federal, state, and/or local laws or regulations, and that I am solely responsible for my actions. I agree that the Electronic Signatures in Global and National Commerce Act (commonly known as the "E-Sign Act"), 15 U.S.C. 7000, et seq, governs this agreement and that by clicking on "Enter" I am confirming my agreement to be bound by the terms of this agreement and affirmatively adopt the signature line below as my signature as the manifestation of my consent to be bound by the terms of this agreement.<br><br>
                            _/s/_______________
                        </p>
                    </div>
                </div>

                <div
                    class="mt-5 flex w-full flex-row items-center justify-center space-x-6 sm:my-6">
                    <button
                        class="w-[90px] items-center hover:border-auditionsBlueHover rounded-md border border-auditionsBlue px-4 py-2 text-xs font-semibold text-[#fff] uppercase tracking-widest focus:outline-none focus:ring-0 focus:ring-offset-0 disabled:opacity-25"
                        @click.prevent="exitSite">
                        Exit
                    </button>
                    <button
                        class="w-[90px] items-center bg-auditionsBlue hover:bg-bg-auditionsBlueHover  rounded-md border text-[#fff] border-auditionsBlue px-4 py-2 text-xs font-semibold uppercase tracking-widest focus:outline-none focus:ring-0 focus:ring-offset-0 disabled:opacity-25"
                        @click.prevent="enterSite()">
                    Enter
                    </button>
                </div>
            </div>
        </template>
    </PopUpDialog>
</template>
<style scoped>
#dialog {
    border: 1px solid #444;
    border-radius: 6px;
    background-color: #101010;
    color: #999;
}
</style>
<script setup>
import { ref, onBeforeMount } from 'vue'
import PopUpDialog from '@/Components/Common/PopUpDialog.vue'
import {usePage} from "@inertiajs/vue3";

const { props } = usePage()
const params = new URLSearchParams(window.location.search)
const displayPopUp = ref(false)

const closePopUp = () => {
    displayPopUp.value = false
}

onBeforeMount(() => {
    setTimeout(() => {
        const nats = params.get('nats')
        if (nats && nats !== '') {
            displayPopUp.value = false
            storeCookie()
            return
        }

        let doc_cookie = document.cookie
        if (doc_cookie.includes('MOCK_nsfw')) {
            displayPopUp.value = false
        } else {
            if (props.app.hasNatsCookie) {
                displayPopUp.value = false
                storeCookie()
                return
            }

            stopVideo()
            displayPopUp.value = true
        }
    }, 500)
})

function enterSite() {
    storeCookie();

    const currentVideoElement = document.querySelector('.current-video video')

    setTimeout(() => {
        if (currentVideoElement) {
            console.log('playing video after accepting nsfw popup')
            currentVideoElement.play()
        }

        displayPopUp.value = false
    }, 500)
}

function stopVideo() {
    const currentVideoElement = document.querySelector('.current-video video')
    if (currentVideoElement) {
        console.log('stopping video in nsfw popup')
        currentVideoElement.pause()
    }
}

const exitSite = () => {
    window.location.href = 'https://en.wikipedia.org/wiki/Pussy'
}

function storeCookie() {
    document.cookie = `MOCK_nsfw='c29tZSBlbmNvZGVkIHZhbHVlcw==';secure: true; expires=${new Date(
        new Date().getTime() + 1000 * 60 * 60 * 24 * 365,
    ).toGMTString()}; path=/;`
}
</script>
